import React from "react";

import RestaurantLandingPage from "demos/RestaurantLandingPage.js";

export default () => {
  return <RestaurantLandingPage />;
};
